module.exports = __webpack_public_path__ + "static/Lato-Light-2fe27d9d10cdfccb1baef28a45d5ba90.ttf";